import { render, staticRenderFns } from "./wbbgts.vue?vue&type=template&id=3ed89f4a&scoped=true&"
import script from "./wbbgts.vue?vue&type=script&lang=js&"
export * from "./wbbgts.vue?vue&type=script&lang=js&"
import style0 from "./wbbgts.vue?vue&type=style&index=0&id=3ed89f4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed89f4a",
  null
  
)

export default component.exports